export enum RASTER_COLORMAP_NAMES {
    msatCoolLog = 'msat_cool_log',
    msatFlirLog = 'msat_flir_log',
    mairWarmLinear = 'mair_warm_linear',
    msatWarmDefault = 'msat_warm_default',
    msatWarmExtended = 'msat_warm_extended',
    msatWarmHighContrast = 'msat_warm_highcontrast',
    msatDimState = 'msat_dim_state'
}
